import {
  inject,
  Injectable,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import {
  UserInformation,
  UserPreferences,
  UserSettings,
} from '../interfaces/interfaces';
import { ApiService } from '../services/api-services/api.service';
import { catchError, firstValueFrom, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserStore {
  private _userSignal: WritableSignal<UserInformation> =
    signal<UserInformation>(null);
  private _userPreferencesSignal: WritableSignal<UserPreferences> =
    signal<UserPreferences>(null);

  // Computed signals
  public user: Signal<UserInformation> = this._userSignal.asReadonly();
  public userPreferences: Signal<UserPreferences> =
    this._userPreferencesSignal.asReadonly();

  private apiService: ApiService = inject(ApiService);
  constructor() {}

  // API calls
  public getUserInformation() {
    return firstValueFrom(
      this.apiService.getUserInformation().pipe(
        tap((user: UserInformation) => {
          console.log('user', user);
          this._userSignal.set(user);
        }),
        catchError((error) => {
          console.log('error', error);
          return of(null);
        })
      )
    );
  }

  public getUserPreferences() {
    return firstValueFrom(
      this.apiService.getUserPreferences().pipe(
        tap((preferences: UserPreferences) => {
          console.log('preferences', preferences);
          this._userPreferencesSignal.set(preferences);
        }),
        catchError((error) => {
          console.log('error', error);
          return of(null);
        })
      )
    );
  }

  // Actions
  public setUserPreferences(preferences: UserPreferences) {
    this._userPreferencesSignal.set(preferences);
  }

  public resetStoreData() {
    this._userSignal.set(null);
    this._userPreferencesSignal.set(null);
  }

  // Api Calls
  public updateUserSettings(settings: UserSettings) {
    return firstValueFrom(
      this.apiService.updateUserSettings(settings).pipe(
        tap(() => {
          this._userPreferencesSignal.update((prev) => ({
            ...prev,
            userSettings: settings,
          }));
        }),
        catchError((error) => {
          console.log('error', error);
          return of(null);
        })
      )
    );
  }

  public toggleMapFavorite(mapId: string) {
    return firstValueFrom(
      this.apiService.toggleMapFavorite(mapId).pipe(
        tap(() => {
          this._userPreferencesSignal.update((prev) => {
            if (prev.userFavoriteMaps.includes(mapId)) {
              return {
                ...prev,
                userFavoriteMaps: prev.userFavoriteMaps.filter(
                  (id) => id !== mapId
                ),
              };
            } else {
              return {
                ...prev,
                userFavoriteMaps: [...prev.userFavoriteMaps, mapId],
              };
            }
          });
        }),
        catchError((error) => {
          console.log('error', error);
          return of(null);
        })
      )
    );
  }
}
